import * as Yup from 'yup';

// Sentinel value for the "no employee (company-wide)" option in company RFID forms
export const NO_EMPLOYEE_OPTION = 'none';

export interface CreateRfidFormType {
    rfidTag: string;
    licensePlate: string;
    employeeId: string;
}

export interface UpdateRfidFormType {
    blocked: string;
    idTag: string;
    licensePlate: string;
    employeeId: string;
}

export const createRfidFormSchema = Yup.object().shape({
    rfidTag: Yup.string().max(255).required('schemaRequiredRfid'),
    licensePlate: Yup.string().max(32).nullable(),
    employeeId: Yup.string().nullable(),
});

export const updateRfidFormSchema = Yup.object().shape({
    blocked: Yup.string(),
    idTag: Yup.string().required('schemaRequiredRfid'),
    licensePlate: Yup.string().max(32).nullable(),
    employeeId: Yup.string().nullable(),
});
